module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DSelect', {
    attrs: {
      "items": _vm.allCals,
      "isLoading": _vm.isLoading,
      "itemsSelected": _vm.itemsSelected,
      "allDataLoaded": _vm.allDataLoaded,
      "multiple": true,
      "appendToBody": _vm.appendToBody,
      "placeholder": this.$t('vue2.dselect.placeholder_calendars')
    },
    on: {
      "add": function($event) {
        return _vm.$emit('add', $event)
      },
      "remove": function($event) {
        return _vm.$emit('remove', $event)
      },
      "update": function($event) {
        return _vm.$emit('updateItems', $event)
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c93f75fc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DSelect/DSelectCalsAll.vue
// module id = 1746
// module chunks = 1